import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "thu-hoi-detail-blocks"
}
const _hoisted_2 = { class: "thu-hoi-material-header mb-2" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "4",
      class: "text-center"
    }, "Ngày"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "4",
      class: "text-center"
    }, "Diễn giải"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      class: "text-center"
    }, "Thu hồi để thanh lý"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "4",
      class: "text-center"
    }, [
      /*#__PURE__*/_createTextVNode(" Ghi chú"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "thu-hoi-header-help" }, "(Kế toán ký đối chiếu hằng tháng)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "3",
      class: "text-center"
    }, [
      /*#__PURE__*/_createTextVNode(" Tổng số phải thu hồi"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "thu-hoi-header-help" }, "(=Cột 2-B01.b)")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "3",
      class: "text-center"
    }, "Trong đó")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center"
    }, "Mất"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center"
    }, "Thực thu hồi")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Quy đổi ra Kg")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "thu-hoi-col-index-row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "A"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "B"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "1=2+3"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "2"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "3"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "4"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "C")
  ])
], -1)
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = { class: "thu-hoi-col-text" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "thu-hoi-col-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "text-center text-muted"
}, "Không có dữ liệu", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "text-center fw-bolder"
}, "Tổng cộng", -1)
const _hoisted_17 = { class: "text-end fw-bolder" }
const _hoisted_18 = { class: "text-end fw-bolder" }
const _hoisted_19 = { class: "text-end fw-bolder" }
const _hoisted_20 = { class: "text-end fw-bolder" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fst-italic fs-7 mb-0" }, " Số bị mất (cột 2) - Cơ sở ghi là biên bản giải thể. ", -1)
const _hoisted_23 = {
  key: 1,
  class: "text-center text-muted py-5"
}

import { computed, PropType } from "vue";
import { formatDisplayingDate } from "@/core/hooks/use-date-time-hook";
import { formatQuantity } from "@/core/helpers/number-format";
import type { MaterialLiquidationBlock } from "@/types/thu-hoi-vtpt";
import { THU_HOI_COLUMN_WIDTHS } from "./thu-hoi-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThuHoiB02aTable',
  props: {
  blocks: {
    type: Array as PropType<MaterialLiquidationBlock[]>,
    required: true,
  },
  isPrintModal: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const colW = THU_HOI_COLUMN_WIDTHS;

const tableClass = computed(() =>
  props.isPrintModal
    ? "thu-hoi-table bao-cao-table--print"
    : "table core-table thu-hoi-table"
);

const formatNgay = (ngay: string) => formatDisplayingDate(ngay, "/");

return (_ctx: any,_cache: any) => {
  return (__props.blocks.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.blocks, (block) => {
          return (_openBlock(), _createElementBlock("div", {
            key: block.id_vat_tu,
            class: "thu-hoi-detail-block mb-6"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(block.ma_vat_tu), 1),
              _createTextVNode(" — " + _toDisplayString(block.ten_vat_tu) + " ", 1),
              _createElementVNode("span", _hoisted_3, "(ĐVT: " + _toDisplayString(block.don_vi_tinh) + ")", 1),
              (block.vat_tu_thu_hoi)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " VT thu hồi: " + _toDisplayString(block.vat_tu_thu_hoi.ma_vat_tu) + " — " + _toDisplayString(block.vat_tu_thu_hoi.ten_vat_tu), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("table", {
              class: _normalizeClass(tableClass.value)
            }, [
              _createElementVNode("colgroup", null, [
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).ngay}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).text}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
                }, null, 4),
                _createElementVNode("col", {
                  style: _normalizeStyle({ width: `${_unref(colW).text}px` })
                }, null, 4)
              ]),
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${block.id_vat_tu}-${index}`,
                    class: _normalizeClass({
              'bao-cao-table-data-row': __props.isPrintModal,
              'bao-cao-table-data-row--last':
                __props.isPrintModal && index === block.rows.length - 1,
            })
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(formatNgay(row.ngay)), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(row.dien_giai), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatQuantity)(row.tong_phai_thu_hoi)), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatQuantity)(row.mat)), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatQuantity)(row.thuc_thu_hoi_sl)), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatQuantity)(row.thuc_thu_hoi_kg)), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(row.ghi_chu), 1)
                  ], 2))
                }), 128)),
                (!block.rows.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", {
                  class: _normalizeClass({
              'thu-hoi-table-total-row': !__props.isPrintModal,
              'bao-cao-table-total-row': __props.isPrintModal,
            })
                }, [
                  _hoisted_16,
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatQuantity)(block.totals.tong_phai_thu_hoi)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatQuantity)(block.totals.mat)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatQuantity)(block.totals.thuc_thu_hoi_sl)), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatQuantity)(block.totals.thuc_thu_hoi_kg)), 1),
                  _hoisted_21
                ], 2)
              ])
            ], 2)
          ]))
        }), 128)),
        _hoisted_22
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_23, "Không có dữ liệu"))
}
}

})